import useGetMemberContactDetails from "@/features/MyHealth/hooks/useGetMemberContactDetails";
import { formatAddressForTextArea } from "@/utils";
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import LoadingSpinner from "@/features/Common/components/LoadingSpinner";
import Panel from "@/features/Common/components/Panel";
import CircledBackButton from "@/features/Common/components/CircledBackButton";
import { defaultFullscreenPageStyling } from "@/theme";

export default function MyContactDetails() {
  const { t } = useTranslation();

  const {
    memberContactDetails,
    isMemberContactDetailsLoading,
    memberContactDetailsFetchError,
  } = useGetMemberContactDetails();

  return (
    <Stack sx={{ ...defaultFullscreenPageStyling }} spacing={4}>
      <CircledBackButton showLabel={true} />
      <Stack spacing={1}>
        <Typography variant="h2">{t("More.myContactDetails.title")}</Typography>
      </Stack>

      <Panel>
        {isMemberContactDetailsLoading ? (
          <Stack alignItems="center">
            <LoadingSpinner />
          </Stack>
        ) : (
          <>
            {memberContactDetails && !memberContactDetailsFetchError && (
              <>
                <Stack spacing={2} p={1}>
                  <Stack>
                    <Typography
                      variant="body2"
                      sx={{ color: (theme) => theme.palette.neutral[500] }}
                    >
                      {t("common.fullNameInputLabel")}
                    </Typography>
                    <Typography>
                      {memberContactDetails.firstName}{" "}
                      {memberContactDetails.lastName}
                    </Typography>
                  </Stack>
                  {memberContactDetails.mobileNumber && (
                    <Stack>
                      <Typography
                        variant="body2"
                        sx={{ color: (theme) => theme.palette.neutral[500] }}
                      >
                        {t("common.phoneNumberInputLabel")}
                      </Typography>
                      <Typography>
                        {memberContactDetails.mobileNumber}
                      </Typography>
                    </Stack>
                  )}
                  {memberContactDetails.emailAddress && (
                    <Stack>
                      <Typography
                        variant="body2"
                        sx={{ color: (theme) => theme.palette.neutral[500] }}
                      >
                        {t("common.emailAddressInputLabel")}
                      </Typography>
                      <Typography>
                        {memberContactDetails.emailAddress}
                      </Typography>
                    </Stack>
                  )}
                  {memberContactDetails.homeAddress &&
                    Object.values(memberContactDetails.homeAddress).every(
                      (value) => value
                    ) && (
                      <Stack>
                        <Typography
                          variant="body2"
                          sx={{ color: (theme) => theme.palette.neutral[500] }}
                        >
                          {t("common.physicalAddressInputLabel")}
                        </Typography>
                        <Typography sx={{ whiteSpace: "pre-wrap" }}>
                          {formatAddressForTextArea(
                            memberContactDetails.homeAddress
                          )}
                        </Typography>
                      </Stack>
                    )}
                </Stack>
              </>
            )}

            {(memberContactDetailsFetchError ||
              memberContactDetails === null) && (
              <Typography variant="h2" align="center">
                {t("common.somethingWentWrong")}
              </Typography>
            )}
          </>
        )}
      </Panel>
    </Stack>
  );
}
